import styled from 'styled-components'
import theme from '../../styles/theme'

const StHeader = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1;
	height: ${theme.headerHeight};
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 1rem;
	background: linear-gradient(rgba(0,0,0,0.3), transparent);
	.slot-1{
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.slot-2{
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.btn-menu{
		margin-left: 10px;
		cursor: pointer;
		font-size: 1.8rem;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.btn-suscribete{
		background-color: ${theme.color};
		color: ${theme.background};
    text-decoration: none;
		border-radius: 4px;
		font-family: 'Acta Sans', sans-serif;
		font-size: 0.8rem;
		padding: 0.55rem 0.6rem 0.4rem;
		text-transform: uppercase;
		margin: 6px 1rem;
		line-height: 0.8rem;
		display: block;
		border: 1px solid ${theme.color};
		&:hover{
			background-color: ${theme.background};
			color: ${theme.color};
			border: 1px solid ${theme.color};
		}
	}
`

const StLogo = styled.h1`
	font-family: ${theme.fontbody};
	font-size: 9px;
	text-align: center;
	color: black;
	&.logo-culto{
		svg{
			min-width: 80px;
			width: 80px;
		}
	}
	&.logo-latercera{
		margin-left: 5px;
		svg{
			min-width: none;
			width: 40px;
		}
	}
	&.icon-latercera{
		overflow: hidden;
		margin-left: 5px;
		/* @media(max-width: 800px){
			display: block;
		} */
		img{
			width: 20px;
			height: 20px;
		}
	}
	svg{
		min-width: 120px;
		max-width: 120px;
		max-height: 30px;
		@media (max-width: 800px) {

		}
	}

`;

export { StHeader, StLogo }